import { ref, onMounted, onUnmounted } from 'vue';
import debounce from '~/utils/debounce';

export const useTabBarRefElement = () => {
  const tabBarHeight = ref<number>(0);
  const tabBarRef = ref<HTMLElement | null>(null);
  let resizeObserver: ResizeObserver | null = null;

  const updateTabBarHeight = () => {
    if (tabBarRef.value) {
      tabBarHeight.value = tabBarRef.value.offsetHeight;
    }
  };

  const handleResize = debounce(() => {
    updateTabBarHeight();
  }, 100);

  onMounted(() => {
    if (tabBarRef.value) {
      updateTabBarHeight();
      resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(tabBarRef.value);
      window.addEventListener('resize', handleResize);
      tabBarHeight.value = 0;
    }
  });

  onUnmounted(() => {
    if (resizeObserver && tabBarRef.value) {
      resizeObserver.unobserve(tabBarRef.value);
    }
    window.removeEventListener('resize', handleResize);
    document.documentElement.style.setProperty('--tab-bar-height', `${0}px`);
  });

  watch(() => tabBarHeight.value, (newHeight) => {
    if (document) {
      document.documentElement.style.setProperty('--tab-bar-height', `${newHeight}px`);
    }
  });

  return {
    tabBarHeight,
    tabBarRef,
  };
};
